import React from 'react';
import classNames from 'classnames';
import { PerfectScrollbar } from '../../../../shared/ReactPerfectScrollbar';

function DMActionsTableBody({ children, className, style }) {
  return (
    <PerfectScrollbar className={classNames('rt-tbody', className)} style={style} options={{ wheelPropagation: false }}>
      {children}
    </PerfectScrollbar>
  );
}

export default DMActionsTableBody;
